export const MENU_COLOR = Object.freeze({
  1: {
    main: 0x32454c,
    border: 0x6d9aa8,
  },
  2: {
    main: 0x324c3a,
    border: 0x6da87d,
  },
  3: {
    main: 0x38324c,
    border: 0x796da8,
  },
});
